import { store } from "@redux"

const isNewItemInPreviousOrder = (orderItem) => {
  const {
    orderForEditDetails
  } = store.getState()

  const previousOrder =
    orderForEditDetails

  if (previousOrder === null) return false

  const isNew =
    previousOrder.items.some(previousOrderItem =>
      previousOrderItem.optionId === orderItem.optionId &&
      previousOrderItem.quantity === orderItem.quantity &&
      previousOrderItem.salePrice === orderItem.salePrice
    )

  return !isNew
}

export default isNewItemInPreviousOrder